import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { remove } from '../../actions/ad-subscription';

import type { SubscriptionAdvertisement } from '../../@types/AdvertismentSubscription';
import { Button } from '../../styled-components/components/Button';
import Modal from '../../styled-components/components/Modal';

interface AdSubscriptionRemoveModalProps {
  subscription?: SubscriptionAdvertisement | null;
  onClose: () => void;
}

const AdSubscriptionRemoveModal = ({ subscription, onClose }: AdSubscriptionRemoveModalProps) => {
  const { t } = useTranslation(['list']);
  const dispatch = useDispatch();

  const actions = bindActionCreators(
    {
      remove,
    },
    dispatch,
  );

  return (
    <Modal
      heading={t('removeSavedAdHeading', { ns: 'list' })}
      onClose={onClose}
      footerActions={[
        <Button
          key="ad-remove-cancel"
          onClick={onClose}
          title={t('cancel', { ns: 'common' })}
          $tone="clear"
          $fullWidth
        >
          {t('cancel', { ns: 'common' })}
        </Button>,
        <Button
          key="ad-remove-save"
          onClick={() => {
            if (subscription) {
              actions.remove(subscription);
              onClose();
            }
          }}
          title={t('removeSavedAdButtonText', { ns: 'list' })}
          $tone="primary"
          $fullWidth
        >
          {t('removeSavedAdButtonText', { ns: 'list' })}
        </Button>,
      ]}
    >
      {t('removeSavedAdBody', { ns: 'list' })}
    </Modal>
  );
};

export default AdSubscriptionRemoveModal;
